export default {
  namespaced: true,
  state: {
    showToast: false,
    toastTimer: null,
    toastDesc: ""
  },
  getters: {
    showToast: state => state.showToast,
    toastDesc: state => state.toastDesc
  },
  mutations: {
    showToast(state, toastDesc) {
      if (state.toastTimer) {
        window.clearTimeout(state.toastTimer)
        state.toastTimer = null
      }
      state.toastDesc = toastDesc
      state.showToast = true
      state.toastTimer = window.setTimeout(() => {
        window.clearTimeout(state.toastTimer)
        state.toastTimer = null
        state.showToast = false
      }, 3000)
    }
  }
}
